
import Vue from "vue";

export const props = {
  address: {
    required: true
  },
  dealerCode: {
    required: false
  },
  showName: {
    required: false,
    default: true
  }
};

export const PostalAddress = Vue.extend({
  name: "PostalAddress",
  functional: true,
  props,
  render: function (h, { props }) {
    const { address, dealerCode, showName } = props;
    
    if (!address) {
      return null;
    }

    const hasStreetAdddress = () => {
      return address.AddressLine1 || address.AddressLine2 || address.AddressLine3;
    }
    const children = [];
    
    if (address.Name && showName && address.Name !== address.AddressLine1) {
      children.push(h("span", { attrs: { itemprop: "name" } }, dealerCode ? `address.Name (${dealerCode})` : address.Name));
      children.push(h("br"));

      if( address.Name2){
        children.push(h("span", {attrs: { itemprop: "name2" } }, address.Name2 ))
        children.push(h("br"));
      }
    }

    if (hasStreetAdddress()) {

      const streetLines = [];

      if (address.AddressLine1) {
        streetLines.push(address.AddressLine1);
        streetLines.push(h("br"));
      }

      if (address.AddressLine2) {
        streetLines.push(address.AddressLine2);
        streetLines.push(h("br"))
      }

      if (address.AddressLine3) {
        if (!address.City || address.AddressLine3.indexOf(address.City) === -1) {
          streetLines.push(address.AddressLine3)
        }
      }

      children.push(h("div", { attrs: { itemprop: "streetAddress" } }, streetLines));
    }

    if (address.City) {
      children.push(h("span", { attrs: { itemprop: "addressLocality" } }, address.City));
    }

    if (address.StateProvinceCode) {
      if (address.City) {
        children.push(", ");
      }
      children.push(h("span", { attrs: { itemprop: "addressRegion" } }, address.StateProvinceCode));
    }

    if (address.PostalCode) {
      if (address.PostalCode) {
        children.push(" ");
      }
      children.push(h("span", { attrs: { itemprop: "postalCode" } }, address.PostalCode));
    }

    if (address.CountryCode && address.CountryCode != "US" && address.CountryCode != "USA") {
      children.push(h("br"));
      children.push(h("span", { attrs: { itemprop: "addressCountry" } }, address.CountryCode));
    }

    return h(
      "div",
      { class: "address", attrs: { itemscope: true, itemprop: "address" } },
      [children]
    );
  }
});

export default PostalAddress;
